import { getCommonSelectorProps } from "common/app/command-palette/selectors";
import { RenderModuleProps } from "common/app/command-palette/types";
import { getQueryString } from "common/app/query-string";
import { changeSite, removeIdFromPath } from "common/utils/site";
import { getWindowLocation } from "common/utils/window-location";
import { SiteSelector } from "common/widgets/site-selector";

export function SiteSwitchModule({
  context,
  goTo,
  onCommandSelected,
}: Readonly<RenderModuleProps>) {
  const onSiteSelected = (sites: string[]) => {
    const site = sites[0];
    const location = getWindowLocation();
    const path = location.pathname;
    const queryString = getQueryString(location);
    const newPath =
      path.indexOf("/admin/") !== -1 ? path : removeIdFromPath(path);
    const newUrl = changeSite(newPath, queryString, site);

    goTo(newUrl);
    onCommandSelected();
  };

  return (
    <SiteSelector
      {...getCommonSelectorProps()}
      allowMultipleSelection={false}
      hideTreeSelector={true}
      openAfterFetch={true}
      context={context}
      value={undefined}
      onChange={onSiteSelected}
    />
  );
}

SiteSwitchModule.displayName = "SiteSwitchModule";
